import { Buffer } from 'buffer'

export default function decodeJwtToken(token: string): any {
  const payload = token.split('.')[1]
  return JSON.parse(Buffer.from(payload, 'base64').toString('utf8'))
}
